import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

export default function Package() {
  const headers = {
    token: localStorage.getItem("userToken"),
  };
  let [Package, setPackage] = useState([]);

  async function addPackage() {
    let name = document.getElementById("nameOfPackage").value;
    let description = document.getElementById("description").value;
    let price = document.getElementById("price").value;
    let mileage = document.getElementById("mileage").value;
    let productIds = document.getElementById("productIds").value; 
    let logo = document.getElementById("images").files;
  
    if (!name || !price || !description || !mileage || !productIds) {
      Swal.fire({
        icon: "warning",
        title: "You must enter all inputs.",
        confirmButtonText: "Ok",
      });
      return;
    }
  
    productIds = productIds.split(',').map(id => id.trim());
  
    if (productIds.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "You must provide at least one product ID.",
        confirmButtonText: "Ok",
      });
      return;
    }
  
    let formData = new FormData();
    formData.append("name", name);
    formData.append("description", description);
    formData.append("price", price);
    formData.append("mileage", mileage);
    productIds.forEach((id) => {
    formData.append("productIds", id); 
    });
  
    const validExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
  
    for (let i = 0; i < logo.length; i++) {
      let fileName = logo[i].name.toLowerCase();
      let fileExtension = fileName.split(".").pop();
      if (!validExtensions.includes(fileExtension)) {
        Swal.fire({
          icon: "warning",
          title: "Please upload an image in a supported format only (jpg, jpeg, png, gif, bmp, webp).",
          confirmButtonText: "Ok",
        });
        return;
      }
      formData.append("logo", logo[i]);
    }
  
    try {
      const response = await axios.post(
        "https://vehex-production.up.railway.app/package/createPackage",
        formData,
        { headers }
      );
      console.log(response.data)
      if (response.data.message === "Package created successfully.") {
        Swal.fire({
          icon: "success",
          title: "Package added successfully",
          confirmButtonText: "Ok",
        });
      }
      getPackage();
    } catch (error) {
      console.error("Error:", error.response ? error.response.data : error.message);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please try again!",
        confirmButtonText: "Ok",
      });
    }
  }
  

  async function getPackage() {
    try {
      let res = await axios.get("https://vehex-production.up.railway.app/package/allPackages");
     setPackage(res.data.packages)
     console.log(res.data)
    } catch (error) {
      console.error(

        error.response ? error.response.data : error.message
      );

    }
  }

  async function deletePackage(id) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let response = await axios.delete(
            `https://vehex-production.up.railway.app/package/deletePackage/${id}`,
            { headers }
          );
          if (response.data.message === "Package deleted successfully.") {
            Swal.fire({
              title: "The Package has been deleted.",
              icon: "success",
              confirmButtonColor: "#3085d6",
            });
            getPackage();

          }
        } catch (error) {
          console.error("Error deleting Package:", error);
          Swal.fire({
            title: "Error!",
            text: "There was an issue deleting the  Package.",
            icon: "error",
            confirmButtonColor: "#d33",
          });
        }
      }
    });
  }



  let[pckId,setpckid]=useState(null)
function setFormForUpdate(pckId) {
  setpckid(pckId)
  window.scrollTo({
    top: 0,    
    behavior: "smooth", 
  });
  const selectedPackage = Package.find((cat) => cat._id === pckId);
  if (selectedPackage) {
    document.getElementById("PackageForm").classList.replace("d-block", "d-none");
    document.getElementById("PackageFormUpdate").classList.replace("d-none", "d-block");
    document.getElementById("nameOfPackagee").value = selectedPackage.name || "";
    document.getElementById("descriptionn").value = selectedPackage.description || "";
    document.getElementById("productIdss").value = 
    selectedPackage.products.map(product => product._id).join(",") || "";

  
      document.getElementById("pricee").value = selectedPackage.price || "";
      document.getElementById("mileagee").value = selectedPackage.mileage || "";
   
  }
}
async function updatePackage(pckId) {
  let name = document.getElementById("nameOfPackagee").value;
  let description = document.getElementById("descriptionn").value;
  let price = document.getElementById("pricee").value;
  let mileage = document.getElementById("mileagee").value;
  let productIds = document.getElementById("productIdss").value; 
  let logo = document.getElementById("imagess").files;


  productIds = productIds.split(',').map(id => id.trim());

  if (productIds.length === 0) {
    Swal.fire({
      icon: "warning",
      title: "You must provide at least one product ID.",
      confirmButtonText: "Ok",
    });
    return;
  }

  let formData = new FormData();
  formData.append("name", name);
  formData.append("description", description);
  formData.append("price", price);
  formData.append("mileage", mileage);
  productIds.forEach((id) => {
  formData.append("productIds", id); 
  });

  const validExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];

  for (let i = 0; i < logo.length; i++) {
    let fileName = logo[i].name.toLowerCase();
    let fileExtension = fileName.split(".").pop();
    if (!validExtensions.includes(fileExtension)) {
      Swal.fire({
        icon: "warning",
        title: "Please upload an image in a supported format only (jpg, jpeg, png, gif, bmp, webp).",
        confirmButtonText: "Ok",
      });
      return;
    }
    formData.append("logo", logo[i]);
  }

  try {
    const response = await axios.put(
      `https://vehex-production.up.railway.app/package/updatePackage/${pckId}`,
      formData,
      { headers }
    );
    console.log(response.data)
    if (response.data.message === "Package updated successfully.") {
      Swal.fire({
        icon: "success",
        title: "Package updated successfully",
        confirmButtonText: "Ok",
      });
    }
    document.getElementById("PackageForm").classList.replace("d-none", "d-block");
    document.getElementById("PackageFormUpdate").classList.replace("d-block", "d-none");
    getPackage();
  } catch (error) {
    console.error("Error:", error.response ? error.response.data : error.message);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Please try again!",
      confirmButtonText: "Ok",
    });
  }
}

  useEffect(() => {
    getPackage()
  },[]);

  return (
    <>
      <form
        className="ProductForm overflow-x-auto mb-5 d-block"
        id="PackageForm"
        onSubmit={(e) => e.preventDefault()}
      >
        <h1 className="heading">Add Package</h1>
        <div className="d-grid">
          <div>
            <label
              htmlFor="nameOfPackage"
              className="mb-1 fs-5 fw-500 main-color"
            >
              Name
            </label>
            <input
              type="text"
              name="nameOfPackage"
              id="nameOfPackage"
              className="form-control fs-5 mb-2"
            />

            <label
              htmlFor="description"
              className="mb-1 fs-5 fw-500 main-color"
            >
              Description
            </label>
            <input
              type="text"
              name="description"
              id="description"
              className="form-control fs-5 mb-2"
            />

            <label htmlFor="productIds" className="mb-1 fs-5 fw-500 main-color">
              Product Ids [ You must enter 2 id at least between of them , ]
            </label>
            <input
              type="text"
              name="productIds"
              id="productIds"
              className="form-control fs-5 mb-2"
            />
          </div>
          {/* ========================================== */}

          <div>
            <label htmlFor="price" className="mb-1 fs-5 fw-500 main-color">
              Price
            </label>
            <input
              type="number"
              name="price"
              id="price"
              className="form-control fs-5 mb-2"
            />

            <label htmlFor="mileage" className="mb-1 fs-5 fw-500 main-color">
              Mailage
            </label>
            <input
              type="number"
              name="mileage"
              id="mileage"
              className="form-control fs-5 mb-2"
            />

              <label htmlFor="files" class="fw-bold main-color">Upload Imgs</label>
                <input
                  type="file"
                  id="images"
                  name="carImage"
                  className="form-control mb-3"
                  multiple
                  required
                />
                <p class="fw-bold fs-6 text-black">Please add 2 image at least and max 4  </p>
          </div>
        </div>
        <button
          type="submit"
          onClick={() => addPackage()}
          className=" fs-5 mt-2 fw-500 "
        >
          Add Package
        </button>
      </form>

      <form
        className="ProductFormUpdate overflow-x-auto mb-5 d-none"
        id="PackageFormUpdate"
        onSubmit={(e) => e.preventDefault()}
      >
        <h1 className="heading">Update Package</h1>
        <div className="d-grid">
          <div>
            <label
              htmlFor="nameOfPackage"
              className="mb-1 fs-5 fw-500 main-color"
            >
              Name
            </label>
            <input
              type="text"
              name="nameOfPackage"
              id="nameOfPackagee"
              className="form-control fs-5 mb-2"
            />

            <label
              htmlFor="description"
              className="mb-1 fs-5 fw-500 main-color"
            >
              Description
            </label>
            <input
              type="text"
              name="description"
              id="descriptionn"
              className="form-control fs-5 mb-2"
            />

            <label htmlFor="productIds" className="mb-1 fs-5 fw-500 main-color">
              Product Ids [ You must enter 2 id at least and between of them , ]
            </label>
            <input
              type="text"
              name="productIds"
              id="productIdss"
              className="form-control fs-5 mb-2"
            />
          </div>
          {/* ========================================== */}

          <div>
            <label htmlFor="price" className="mb-1 fs-5 fw-500 main-color">
              Price
            </label>
            <input
              type="number"
              name="price"
              id="pricee"
              className="form-control fs-5 mb-2"
            />

            <label htmlFor="mileage" className="mb-1 fs-5 fw-500 main-color">
              Mailage
            </label>
            <input
              type="number"
              name="mileage"
              id="mileagee"
              className="form-control fs-5 mb-2"
            />

              <label htmlFor="files" class="fw-bold main-color">Upload Imgs</label>
                <input
                  type="file"
                  id="imagess"
                  name="carImage"
                  className="form-control mb-3"
                  multiple
                  required
                />
                <p class="fw-bold fs-6 text-black">Please add 2 image at least and max 4  </p>
          </div>
        </div>
        <button
          type="submit"
          onClick={() => updatePackage(pckId)}
          className=" fs-5 mt-2 fw-500 "
        >
          Update Package
        </button>
      </form>

      <div className=" overflow-x-auto">
        {Package?.length>0?<>        <table className=" table table-striped">
          <thead>
            <tr>
              <th>Logo</th>
              <th>Name</th>
              <th>Description</th>
              <th>Price</th>
              <th>Mailage</th>
              <th>Update</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {Package?.map((pck) => (
          <tr key={pck._id}>
          <td>
              <img src={pck?.images[0]?.url} width={70} height={60} alt="" />
            </td>
            <td>{pck.name}</td>
            <td>{pck.description}</td>
            <td>{pck.price}</td>
            <td>{pck.mileage}</td>
            <td>
              <button
                className="btn btn-success"
                onClick={() => setFormForUpdate(pck._id)}
              >
                Update
              </button>
            </td>
            <td>
              <button
                className="btn btn-danger"
                onClick={() => deletePackage(pck._id)}
              >
                Delete
              </button>
            </td>
          </tr>
         ))}  
          </tbody>
        </table></>:<div className="main-color fs-5 fw-500 text-center">No Package Found </div>}

      </div>
    </>
  );
}
